import React, {Component} from 'react';

const Loading = () => {
    return (
        <div style={{textAlign: 'center'}}><div className="spinner-border" role="status"><span className="sr-only">Loading...</span></div></div>
    );
};

export default Loading;
